import React, { useState, useEffect } from "react";
import {
    Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText,
    Grid, MenuItem, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TextField, Typography, Card,
    CardContent, Dialog, DialogTitle, DialogContent, DialogActions,
    Icon, Tooltip
} from "@mui/material";
import { Delete, Cancel } from "@mui/icons-material";
import Loader from "../../components/Loader";
import { useTranslation, withTranslation } from "react-i18next";
import CommonPagination from "../../components/CommonPagination";
import { DeleteActionUrl, GetClientDetailsUrl, DeleteDashboardUserUrl, getFillListUrl, UpdateUserDetailsUrl, InsertUserDetailsUrl, dashboardUserCountryActionID } from "../../utils/constants";
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useToast } from "../../components/toast";
import { HeaderBlock } from "@colliers/colliers-b2c";

const ClientUserManage = () => {
    const { t } = useTranslation();
    const { ToastComponent, showToast } = useToast();
    //navigate
    const navigate = useNavigate();
    const location = useLocation();
    //state
    const [EditClientID, setEditClientID] = useState(location.state?.userID || null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [dashboardGrpList, setDashboardGrpList] = useState([]);
    const [userName, setUserName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [basecountryID, setBasecountryID] = useState('');
    const [activeDashboard, setActiveDashboard] = useState('');
    const [viewedDashboard, setViewedDashboard] = useState('');

    //fillist
    const [clientCountryFillList, setCountryFillList] = useState([]);
    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const listItemsPerPage = 10;
    const totalItems = dashboardGrpList?.length;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedDashboardGrpList = dashboardGrpList?.slice(startIndex, startIndex + listItemsPerPage);
    //translation
    //common
    const TAction = t("common.Action");
    const TnoRecordFound = t("common.noRecordFound");
    const Tdisable = t("common.disable");
    const Tcancel = t("common.Cancel");
    const Tsave = t("common.Save");
    const Tdashboard = t("common.Dashboard");
    //list
    const TpageTitle = t("clientPage.pageTitle")
    const Tname = t("clientPage.Name")
    const Temail = t("clientPage.Email")
    const TenterName = t("clientPage.enterName")
    const TenterEmail = t("clientPage.addEmail")
    const TclientDetails = t("clientPage.clientDetails")
    const TActiveDashboards = t("clientPage.ActiveDashboards")
    const TViewedDashboards = t("clientPage.ViewedDashboards")
    const TListofAccessibleDashboards = t("clientPage.ListofAccessibleDashboards")
    const TGroup = t("clientPage.Group")
    const TAccessRight = t("clientPage.AccessRight")
    const TvalidTill = t("clientPage.validTill")
    const TdeleteClient = t("clientPage.deleteClient")
    const TdeleteClientConfirm = t("clientPage.deleteClientConfirm")

    const [validate, setValidate] = useState(false);


    useEffect(() => {
        const userInfoString = localStorage.getItem("userInfo");

        if (!userInfoString) {
            navigate("/login/root-data");
            return;
        }
        try {
            const userInfo = JSON.parse(userInfoString);
            console.log("Parsed userInfo:", userInfo);
            fetchData(); 
        } catch (error) {
            console.error("Failed to parse userInfo:", error);
            navigate("/login/root-data");
        }
    }, []);



    const fetchData = async () => {
        setIsLoading(true);
        try {
            let updatedAccessCountries = [];
            const data = await axiosGet(getFillListUrl, {
                actionID: dashboardUserCountryActionID,
                valueID: location.state?.userID,
                keyValue: null
            });
            if (data != null && data.length > 0) {
                setCountryFillList(data);
                updatedAccessCountries = data.map(item => ({
                    ...item,
                    defaultChecked: false
                }));
                setAccessCountries(updatedAccessCountries);
            }
            else {
                console.error("Failed to fetch country list: No data found.");
            }
            getClientDetails(location.state?.userID, updatedAccessCountries);
        }
        catch (error) {
            console.error("Error fetching country list :", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getClientDetails = async (EditClientID, updatedAccessCountries) => {
        try {
            setIsLoading(true);
            const response = await axiosGet(`${GetClientDetailsUrl}?EditClientID=${EditClientID}`);
            if (response) {
                setUserName(response.userName)
                setEmailAddress(response.emailAddress)
                setBasecountryID(response.basecountryID)
                setActiveDashboard(response.activeDashboard)
                setViewedDashboard(response.viewedDashboard)
                setDashboardGrpList(response.clientDashboardGroup)
                if (response.userCountries != null && response.userCountries != undefined && response.userCountries.length > 0) {
                    const countryIdArray = response.userCountries.map(country => parseInt(country.countryID, 10));
                    const newAccessCountries = updatedAccessCountries.map(item => ({
                        ...item,
                        defaultChecked: false
                    }));
                    newAccessCountries.forEach(x => {
                        x.defaultChecked = countryIdArray.includes(Number(x.code));
                    })
                    setAccessCountries(newAccessCountries);

                    const countryIdString = countryIdArray.join(',');
                    setOriginalcountryIds(countryIdString);
                }
            } else {
                console.error("Failed to fetch getClientDetails: Invalid response format.");
                setUserName('')
                setEmailAddress('')
                setBasecountryID('')
                setActiveDashboard('')
                setViewedDashboard('')
                setDashboardGrpList([]);
            }
        } catch (error) {
            console.error("Error fetching getClientDetails:", error);
            setUserName('')
            setEmailAddress('')
            setBasecountryID('')
            setActiveDashboard('')
            setViewedDashboard('')
            setDashboardGrpList([]);
        } finally {
            setIsLoading(false);
        }
    };
    const toggleDeleteModal = (userID) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            setEditClientID('')
        } else {
            setDeleteModal(true);
            setEditClientID(userID);
        }
    };
    const handleDisable = async (userID) => {
        setIsLoading(true);
        try {
            const response = await axiosDelete(DeleteActionUrl, { moduleID: 2, valueID: userID.toString() });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                getClientDetails();
            } else {
                showToast('error', 'Failed to fetch user list: No data found.');
            }
        } catch (error) {
            showToast('error', `Error fetching user list:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false); // Close the modal after the action
        }
    }
    const isValidCountryID = (basecountryID) => {
        return basecountryID !== "" && basecountryID !== null && basecountryID !== "0";
    };
    const errorMessageCountry = validate && !isValidCountryID(basecountryID)
        ? t('user_mgmt.pleaseSelectCountry')
        : '';
    const handleFieldChange = (e, field) => {
        const value = e.target.value
        if (field == 'user') {
            setUserName(value)
        } else if (field == 'email') {
            setEmailAddress(value)
        } else if (field == 'country') {
            const selectedCountryID = e.target.value;
            setBasecountryID(selectedCountryID);
            if (selectedCountryID > 0) {
                const updatedCountries = accessCountries.map((country) =>
                    country.code === selectedCountryID
                        ? { ...country, defaultChecked: true } // Update the matched country
                        : country
                );
                setAccessCountries(updatedCountries);
            }
        }

    };
    const [originalcountryIds, setOriginalcountryIds] = useState("");
    const handleDelete = async (dashboardGroupID, dashboardID) => {
        debugger;
        setIsLoading(true);
        try {
            const response = await axiosDelete(DeleteDashboardUserUrl, { deleteUserID: EditClientID, deleteADGroupID: dashboardGroupID, dashboardID: dashboardID });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                const response1 = await axiosGet(`${GetClientDetailsUrl}?EditClientID=${EditClientID}`);
                if (response1) {
                    setDashboardGrpList(response1.clientDashboardGroup);
                    setActiveDashboard(response1.activeDashboard);
                    setViewedDashboard(response1.viewedDashboard);
                }
            } else {
                showToast('error', 'Failed to Delete');
            }
        } catch (error) {
            showToast('error', `Error in Delete Dashboard:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false); // Close the modal after the action
        }
    }

    const navigateCancel = () => {
        navigate('/client-user-management')
    }

    const validateEmail = () => {
        let check = true;
        let errmsg = "";

        if (emailAddress == "" || emailAddress == null || !is_email(emailAddress)) {
            check = false;
            errmsg = "Invalid Email";
        }
        if (!check) {
            return errmsg;
        }

        return errmsg;
    }
    const is_email = (str) => {

        var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        return !!str.match(validRegex);

    }
    const compareStringIds = (string1, string2) => {
        // Split the strings into arrays
        const array1 = string1.split(",").map(Number); // Convert to numbers if needed
        const array2 = string2.split(",").map(Number);

        // Check if lengths are different
        if (array1.length !== array2.length) return true;

        // Sort both arrays
        const sortedArray1 = array1.sort((a, b) => a - b);
        const sortedArray2 = array2.sort((a, b) => a - b);

        // Compare sorted arrays
        for (let i = 0; i < sortedArray1.length; i++) {
            if (sortedArray1[i] !== sortedArray2[i]) {
                return true; // Return false if any element is different
            }
        }
        return false; // Arrays contain the same items
    };
    const handleSave = async () => {
        setValidate(true);

        const countryAccessTemp = accessCountries?.filter(x => x.defaultChecked)
            .map(x => x.code)
            .join(",") || "";

        if (!isFormValid(userName, basecountryID, countryAccessTemp)) return;

        setIsLoading(true);

        const userPayload = createUserPayload(userName, emailAddress, basecountryID, countryAccessTemp, EditClientID);

        try {
            const response = await axiosPost(EditClientID > 0 ? UpdateUserDetailsUrl : InsertUserDetailsUrl, userPayload);

            if (response.code !== 200) {
                showToast('error', response.responseMsg);
                return;
            }

            handleSuccess(EditClientID);
        } catch (error) {
            console.error(`Error ${EditClientID > 0 ? "updating" : "saving"} user:`, error);
        } finally {
            setIsLoading(false);
        }
    };

    const isFormValid = (userName, basecountryID, countryAccess) => {
        const isUserNameValid = !!userName?.trim();
        const isEmailValid = validateEmail() === "";
        const isBaseCountryValid = basecountryID > 0;
        const hasCountryAccess = !!countryAccess;

        if (isUserNameValid && isEmailValid && isBaseCountryValid && hasCountryAccess) return true;

        console.error("Mandatory fields are required");
        return false;
    };

    const createUserPayload = (userName, emailAddress, basecountryID, countryAccess, EditClientID) => {
        const extractedBaseCountryID = EditClientID > 0 && basecountryID && basecountryID !== "0"
            ? Number(basecountryID)
            : 0;

        const payload = {
            name: userName || "",
            emailAddress: emailAddress || "",
            roleID: EditClientID > 0 ? 2 : 0,
            basecountryID: extractedBaseCountryID,
            updateuserID: EditClientID > 0 ? EditClientID : 0,
            accessRight: null,
            countryAccess: countryAccess,
        };

        if (EditClientID > 0) {
            payload.isCountryChanged = compareStringIds(countryAccess, originalcountryIds);
            payload.isAccessChanged = false;
        }

        return payload;
    };

    const handleSuccess = (EditClientID) => {
        setValidate(false);
        showToast('success', `Successfully ${EditClientID > 0 ? "Updated" : "Saved"}!`);
        setTimeout(() => navigate('/client-user-management'), 1000);
    };

    const [accessCountries, setAccessCountries] = useState([]);

    const handleAccessCountryChange = (code, checked) => {
        if (code == basecountryID && !checked) {
            setBasecountryID("0");
        }
        if (!checked) {
            const updatedCountries = accessCountries.map((country) =>
                country.code === code
                    ? { ...country, defaultChecked: false } // Update the matched country
                    : country
            );
            setAccessCountries(updatedCountries);
        }
        else if (checked) {
            const updatedCountries = accessCountries.map((country) =>
                country.code === code
                    ? { ...country, defaultChecked: true } // Update the matched country
                    : country
            );
            setAccessCountries(updatedCountries);
        }
    }
    const validateCountry = () => {
        if (accessCountries != null && accessCountries != undefined && accessCountries.length > 0) {
            if (accessCountries.filter(x => x.defaultChecked).length > 0) {
                return "";
            }
            else {
                return "country selection is mandatory";
            }
        }
        else {
            return "country selection is mandatory";
        }
    }
    const formatValidUntilDate = (date, t) => {
        debugger;
        if (!date || date === "") return ""; // Handle empty values

        const parsedDate = moment(date, "DD-MM-YYYY HH:mm:ss"); // 'true' ensures strict parsing
        return parsedDate.isValid() ? parsedDate.format("DD MMM YYYY") : t("common.invalidDate");
    };

    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={TpageTitle} leftCenterAlign="true" actionsCenterAlign="true" />

            <main
                id="main"
                className="clientMain"
            >
                <Box>
                    <Box className="clientNoBorder" mb={3}>
                        <Card className="padding-top-s padding-left-base shadow-0 border-light border-radius-soft border-radius padding-bottom-none">
                            <CardContent>
                                <Typography className="font-size-h5 text-primary margin-bottom-xs text-uppercase padding-top-xs clientColor" variant="h6" gutterBottom>
                                    {TclientDetails}
                                </Typography>

                                <Box className="clientHeight"></Box>
                                <Grid container spacing={2} mb={4}>
                                    <Grid item xs={6} sm={3}>
                                        <Box className="text-align-center border-light border-radius-soft padding-xs padding-y-base">
                                            <Typography variant="h5" fontWeight="bold" className="text-primary">
                                                {activeDashboard != null ? activeDashboard : 0}
                                            </Typography>
                                            <Typography className="text-primary-dark">{TActiveDashboards}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box className="text-align-center border-light border-radius-soft padding-xs padding-y-base">
                                            <Typography variant="h5" fontWeight="bold" className="text-primary">
                                                {viewedDashboard != null ? viewedDashboard : 0}
                                            </Typography>
                                            <Typography className="text-primary-dark">{TViewedDashboards}</Typography>                    </Box>
                                    </Grid>
                                </Grid>
                                {/* Filters */}
                                <Grid container spacing={2} mb={3}>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            label={Tname}
                                            variant="outlined"
                                            sx={{ paddingTop: "10px", width: "93%" }}
                                            placeholder={TenterName}
                                            value={userName}
                                            onChange={(e) => handleFieldChange(e, 'user')}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={validate && (userName == "" || userName == null)}
                                            helperText={(validate && (userName == "" || userName == null)) ? t('user_mgmt.pleaseEnterName') : ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            label={Temail}
                                            variant="outlined"
                                            sx={{ paddingTop: "10px", width: "93%" }}
                                            placeholder={TenterEmail}
                                            value={emailAddress}
                                            onChange={(e) => handleFieldChange(e, 'email')}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={validate && validateEmail() != ""}
                                            helperText={(validate && validateEmail() != "") ? t('user_mgmt.pleaseEnterEmail') : ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            label="Country"  // You can replace Tcountry with a translation here
                                            variant="outlined"
                                            select
                                            fullWidth
                                            sx={{ paddingTop: "10px", width: "93%" }}
                                            placeholder="Select Country"  // You can replace TaddCountry with a translation here
                                            value={basecountryID}
                                            onChange={(e) => handleFieldChange(e, 'country')}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={validate && !isValidCountryID(basecountryID)}
                                            helperText={errorMessageCountry}
                                        >
                                            {clientCountryFillList.map((role) => (
                                                <MenuItem key={role.code} value={role.code}>
                                                    {role.description}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={12} className="padding-top-none">
                                        <Typography variant="h6" className="padding-bottom-none font-size-h5 text-primary margin-bottom-xs text-uppercase padding-top-xs clientColor" textTransform="uppercase">
                                            {t('user_mgmt.accessibleCountry')} <span className="clientColorRed">&nbsp;*</span>
                                        </Typography>
                                        {accessCountries.map((country, index) => (
                                            <FormControl className="margin-top-s clientMarginLeft" key={index} error={validate && validateCountry() !== ""}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={country.defaultChecked}
                                                        onChange={(e) => handleAccessCountryChange(country.code, e.target.checked)}
                                                    />}
                                                    label={country.description}
                                                />
                                                {index === accessCountries.length - 1 && validate && validateCountry() !== "" && (
                                                    <FormHelperText>
                                                        {t('user_mgmt.pleaseSelectOneCountry')}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        ))}
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                    <Box className="site-border border-light padding-y-base padding-x-base border-radius" >
                        <Typography className="font-size-h5 text-primary margin-bottom-xs text-uppercase " variant="h6" gutterBottom>
                            {TListofAccessibleDashboards}
                        </Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="padding-left-none">{Tdashboard}</TableCell>
                                        <TableCell>{TGroup}</TableCell>
                                        <TableCell>{TAccessRight}</TableCell>
                                        <TableCell>{TvalidTill}</TableCell>
                                        <TableCell align="center">{TAction}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedDashboardGrpList?.length > 0 ? paginatedDashboardGrpList.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="padding-left-none">{item.dashboardName}</TableCell>
                                            <TableCell>{item.dashboardGroup}</TableCell>
                                            <TableCell>{item.accessRight}</TableCell>
                                            <TableCell>{formatValidUntilDate(item.validUntil, t)}</TableCell>
                                            <TableCell align="center">
                                                {/* <IconButton color="error" >
                              <DeleteIcon />
                            </IconButton> */}

                                                <Button className="" sx={{ margin: '0px !important' }}>
                                                    <Tooltip title="Remove">
                                                        <Icon className='fa-light fa-trash-can font-size-base text-primary btn-list' onClick={() => handleDelete(item.dashboardGroupID, item.dashboardID)} />
                                                    </Tooltip>
                                                </Button>


                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={5}>{TnoRecordFound}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <CommonPagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </Box>
                </Box>
                {/* Buttons */}
                <Box display="flex" justifyContent="center" mt={2} gap={2}>
                    <Button variant="contained" color="primary" onClick={() => handleSave()}>
                        {Tsave}
                    </Button>
                    <Button variant="outlined" color="primary" onClick={() => navigateCancel()}>
                        {Tcancel}
                    </Button>
                    <Button variant="contained" color="error" onClick={() => toggleDeleteModal(EditClientID)}>
                        {Tdisable}
                    </Button>
                </Box>

            </main>

            <Dialog
                open={isDeleteModal}
                className="clientDialog"
            >
                <DialogTitle>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        className="clientDialogTitle"
                    >
                        {TdeleteClient}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography className="clientDialogContent">
                        {TdeleteClientConfirm}
                    </Typography>
                </DialogContent>

                <DialogActions className="dialogAction">
                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                        variant="outlined"
                        startIcon={<Cancel />}
                        onClick={() => toggleDeleteModal('')}
                    >
                        {Tcancel}
                    </Button>
                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                        variant="contained"
                        onClick={() => handleDisable(EditClientID)}
                        startIcon={<Delete />}
                    >
                        {Tdisable}
                    </Button>
                </DialogActions>
            </Dialog>
            {ToastComponent}
            <div className="clientHeight1" />
        </>
        //  )}
        //</>
    );
};

export default withTranslation()(ClientUserManage);
